import React, { useRef } from "react";

import { useOutsideAlerter } from "@assets/hooks";
import { CommonTypes } from "@assets/types";

type PopoverProps = {
  /** The elements inside the popover. */
  children?: React.ReactElement | React.ReactElement[];
  /** The function called when closing the popover. */
  onClose?: CommonTypes.CallbackFunction;
};

const Popover = ({ children, onClose = () => {} }: PopoverProps) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, onClose, onClose !== undefined);

  return (
    <div
      className="absolute z-10 w-[26.25rem] bg-neutral-0 border"
      ref={wrapperRef}
    >
      {children}
    </div>
  );
};

export default Popover;
